import React from "react";

interface EditApplicationModalContentProps {
  loading: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

const EditApplicationModalContent = ({
  loading,
  onConfirm,
  onClose,
}: EditApplicationModalContentProps) => (
  <div
    style={{
      padding: "28px 32px",
      textAlign: "center",
    }}
  >
    {/* Icon */}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 52,
          height: 52,
          borderRadius: 12,
          backgroundColor: "rgba(163, 116, 245, 0.1)",
        }}
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#A374F5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      </div>
    </div>

    {/* Title */}
    <h3
      style={{
        fontWeight: 700,
        fontSize: "1.15rem",
        color: "#2D2943",
        marginBottom: 20,
        lineHeight: 1.3,
      }}
    >
      Edit Existing Application
    </h3>

    {/* Description */}
    <p
      style={{
        color: "#666",
        fontSize: "0.9rem",
        lineHeight: 1.6,
        marginBottom: 12,
        textAlign: "left",
      }}
    >
      Editing your application will allow you to make changes to all items that
      you submitted. This action will pause the approval process and the leasing
      manager will be alerted that an edit occurred.
    </p>

    {/* Warning */}
    <p
      style={{
        color: "#888",
        fontSize: "0.9rem",
        lineHeight: 1.6,
        marginBottom: 0,
        textAlign: "left",
      }}
    >
      Would you like to continue?
    </p>

    {/* Buttons */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        marginTop: 24,
      }}
    >
      <button
        onClick={onConfirm}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: "#A374F5",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.7 : 1,
          transition: "background 0.2s ease",
        }}
        onMouseEnter={(e) => {
          if (!loading)
            (e.target as HTMLButtonElement).style.backgroundColor = "#8052D0";
        }}
        onMouseLeave={(e) => {
          (e.target as HTMLButtonElement).style.backgroundColor = "#A374F5";
        }}
      >
        {loading ? "Processing..." : "Edit & Resubmit Application"}
      </button>
      <button
        onClick={() => {
          if (onClose) onClose();
        }}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: "#F5F5F5",
          color: "#2D2943",
          border: "none",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: loading ? "not-allowed" : "pointer",
          transition: "background 0.2s ease",
        }}
        onMouseEnter={(e) => {
          if (!loading)
            (e.target as HTMLButtonElement).style.backgroundColor = "#EBEBEB";
        }}
        onMouseLeave={(e) => {
          (e.target as HTMLButtonElement).style.backgroundColor = "#F5F5F5";
        }}
      >
        Cancel
      </button>
    </div>
  </div>
);

export default EditApplicationModalContent;
